export class SupplierMasterType {
  id: number;
  fsc: string;
  fedexSupplierNumber: string;
  companyName: string;
  sequenceNumber: number;
  supplierMasterTypeOid: number;
  supplierType: string;
  supplierStatus: string;
  supplierStatusDescription: string;
  allTypeSuspendedIndicator: number;
  purchaseOrderSuspendedIndicator: number;
  serviceOrderSuspendedIndicator: number;
  nullPoSoSuspendedIndicator: number;
  allowPoSo: string;
  requiresQa: string;
  dwLoadTimestamp: string;
}
